'use strict';

var _FirebaseAuth = require('./FirebaseAuth');

var _FirebaseAuth2 = _interopRequireDefault(_FirebaseAuth);

var _StyledFirebaseAuth = require('./StyledFirebaseAuth');

var _StyledFirebaseAuth2 = _interopRequireDefault(_StyledFirebaseAuth);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FirebaseAuth = _FirebaseAuth2.default;
exports.StyledFirebaseAuth = _StyledFirebaseAuth2.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /Users/akshetpandey/workspace/thriller-server/~/react-firebaseui/index.js
// module id = 1338
// module chunks = 114276838955818